import styled, { css } from 'styled-components'
import { Link } from 'react-router-dom'
import { ExternalLinkProps } from './types'
import { TFunctionResultChildren } from 'src/components/Core/Typography/Font/types'

export const LinkBaseStyles = css`
  text-decoration: none;
  background-repeat: no-repeat;
  background-size: 100% 100%;
  padding-bottom: 2px;
  transition: background-size .25s ease-out;
  will-change: background-size;

  &:hover {
    /* Set background width to 0% (it needs to be tested) */
    background-size: 0% 100%;
  }
`

const AppLink = styled(Link) <TFunctionResultChildren>`
  ${LinkBaseStyles}
  color: ${props => props.theme.colors.main[(props.color as string) || 'ultraViolet']};
  background-image: linear-gradient(180deg, transparent calc(100% - 2px), ${props => props.theme.colors.main[(props.color as string) || 'ultraViolet']} 2px);

  &:visited {
    color: ${props => props.theme.colors.main[(props.color as string) || 'ultraViolet']};
  }
`

export const LinkStyle = styled('a') <{ color?: string; }>`
  ${LinkBaseStyles}
  color: ${props => props.theme.colors.main[(props.color as string) || 'ultraViolet']};
  background-image: linear-gradient(180deg, transparent calc(100% - 2px), ${props => props.theme.colors.main[(props.color as string) || 'ultraViolet']} 2px);
  font-weight: bold;
  user-select: none;
  cursor: pointer;
  
  &:visited {
    color: ${props => props.theme.colors.main[(props.color as string) || 'ultraViolet']};
  }
`

export const ExternalLink = styled('a').attrs({ target: '_blank', rel: 'noreferrer noopener' }) <ExternalLinkProps>`
  ${LinkBaseStyles}
  color: ${props => props.theme.colors.main[(props.color as string) || 'ultraViolet']};
  font-size: ${props => (props.tag ? props.theme?.font?.size?.[props.tag] : '14px')};
  background-image: linear-gradient(180deg, transparent calc(100% - 2px), ${props => props.theme.colors.main[(props.color as string) || 'ultraViolet']} 2px);

  ${props => props.paddingBottom && css`
    padding-bottom: ${props.paddingBottom};
  `}

  &:visited {
    color: ${props => props.theme.colors.main[(props.color as string) || 'ultraViolet']};
  }
`

export const UnstyledExternalLink = styled('a').attrs({ target: '_blank', rel: 'noreferrer noopener' }) <ExternalLinkProps>`
  text-decoration: none;
  cursor: pointer;
  color: inherit;
`

export const ButtonLink = styled('a').attrs({ target: '_blank', rel: 'noreferrer noopener' }) <TFunctionResultChildren>`
  appearance: none;
  margin: 4px 0;
  padding: 8px 9px;
  text-decoration: none;
  color: ${props => props.theme.colors.main.blank};
  background-color: ${props => props.theme.colors.main.ultraViolet};
  border: 2px solid ${props => props.theme.colors.main.ultraViolet};
  border-radius: 4px;
  font-size: 11px;
  font-weight: bold;
  user-select: none;
  cursor: pointer;
  transition: border 100ms ease-in-out, background-color 100ms ease-in-out;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  text-transform: uppercase;

  &:hover {
    background-color: ${props => props.theme.colors.light.ultraViolet};
    border: 2px solid ${props => props.theme.colors.light.ultraViolet};
  }

  &:focus {
    border: 2px solid ${props => props.theme.colors.main.ultraViolet};
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }

`

export default AppLink
